/* MXEDesignz — site behavior
 * Sticky header, mega panel hover, mobile menu, progress bar, reveal animations,
 * magnetic buttons. Customizer-aware.
 */
(function () {
  "use strict";

  /* ── Sticky scroll state ──────────────────────────────── */
  function updateNavScrolled() {
    var nav = document.getElementById("nav");
    if (!nav) return;
    if (window.scrollY > 10) nav.classList.add("scrolled");
    else nav.classList.remove("scrolled");
  }
  window.addEventListener("scroll", updateNavScrolled, { passive: true });

  /* ── Mega panels (desktop hover) ───────────────────────── */
  function setupMega() {
    var items = document.querySelectorAll(".nmi[data-mega]");
    var activeItem = null;
    var closeTimer = null;

    function openPanel(item) {
      clearTimeout(closeTimer);
      if (activeItem && activeItem !== item) closePanel(activeItem);
      var panel = document.getElementById(item.dataset.mega);
      if (!panel) return;
      item.classList.add("active");
      panel.classList.add("open");
      activeItem = item;
    }
    function closePanel(item) {
      if (!item) return;
      var panel = document.getElementById(item.dataset.mega);
      if (panel) panel.classList.remove("open");
      item.classList.remove("active");
      if (activeItem === item) activeItem = null;
    }
    function closeAll() { if (activeItem) closePanel(activeItem); }

    items.forEach(function (item) {
      item.addEventListener("mouseenter", function () { openPanel(item); });
      item.addEventListener("mouseleave", function () {
        closeTimer = setTimeout(function () { closePanel(item); }, 140);
      });
    });

    document.querySelectorAll(".mega-wrap .mega").forEach(function (panel) {
      panel.addEventListener("mouseenter", function () { clearTimeout(closeTimer); });
      panel.addEventListener("mouseleave", function () {
        closeTimer = setTimeout(closeAll, 140);
      });
    });

    document.addEventListener("click", function (e) {
      if (!e.target.closest(".nmi") && !e.target.closest(".mega")) closeAll();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeAll();
    });
  }

  /* ── Mobile menu globals ───────────────────────────────── */
  window.openMenu = function () {
    var m = document.getElementById("mob-menu");
    if (!m) return;
    m.classList.add("open");
    m.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  };
  window.closeMenu = function () {
    var m = document.getElementById("mob-menu");
    if (!m) return;
    m.classList.remove("open");
    m.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    document.querySelectorAll(".mob-it.open").forEach(function (s) { s.classList.remove("open"); });
  };
  window.toggleMob = function (id) {
    var item = document.getElementById(id);
    if (!item) return;
    var sub = item.querySelector(".mob-sub");
    if (!sub) return;
    var isOpen = item.classList.contains("open");
    document.querySelectorAll(".mob-it.open").forEach(function (s) {
      if (s !== item) s.classList.remove("open");
    });
    item.classList.toggle("open", !isOpen);
  };

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      var m = document.getElementById("mob-menu");
      if (m && m.classList.contains("open")) window.closeMenu();
    }
  });

  /* ── Top progress bar ──────────────────────────────────── */
  var progressEl = document.getElementById("progress");
  if (progressEl) {
    window.addEventListener("scroll", function () {
      var h = document.documentElement;
      var denom = h.scrollHeight - h.clientHeight;
      progressEl.style.width = denom > 0 ? (window.scrollY / denom) * 100 + "%" : "0%";
    }, { passive: true });
  }

  /* ── Scroll reveal observer ────────────────────────────── */
  var io = ("IntersectionObserver" in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("visible");
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.06 })
    : null;

  function observeAll() {
    if (!io) {
      document.querySelectorAll(".reveal, .stagger").forEach(function (el) {
        el.classList.add("visible");
      });
      return;
    }
    document.querySelectorAll(".reveal, .stagger").forEach(function (el) {
      if (!el.classList.contains("visible")) io.observe(el);
    });
  }

  /* ── Smooth anchor scrolling ───────────────────────────── */
  function smoothAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener("click", function (e) {
        var href = a.getAttribute("href");
        if (href === "#" || href.length < 2) return;
        var t = document.querySelector(href);
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: "smooth" }); }
      });
    });
  }

  /* ── Magnetic button micro-effect ──────────────────────── */
  function setupMagnetic() {
    document.querySelectorAll(".btn").forEach(function (btn) {
      btn.addEventListener("mousemove", function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.12;
        var y = (e.clientY - r.top - r.height / 2) * 0.12;
        btn.style.transform = "translate(" + x + "px, " + y + "px) translateY(-3px)";
      });
      btn.addEventListener("mouseleave", function () { btn.style.transform = ""; });
    });
  }

  /* ── Accordion toggle (global) ─────────────────────────── */
  window.toggleAcc = function (btn) {
    var item = btn.parentElement;
    item.classList.toggle("open");
  };

  /* ── Init ──────────────────────────────────────────────── */
  function init() {
    updateNavScrolled();
    setupMega();
    observeAll();
    smoothAnchors();
    setupMagnetic();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  window.addEventListener("load", observeAll);

  // Customizer support
  document.addEventListener("shopify:section:load", function (e) {
    if (!e.target) return;
    if (e.target.querySelector && e.target.querySelector("#nav")) {
      setupMega();
      updateNavScrolled();
    }
    observeAll();
    setupMagnetic();
  });
})();
